module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xMS4zMzQgNy0zLjE3NyAzLjI2NmEuMjIyLjIyMiAwIDAgMS0uMTU3LjA2Ny4yMTYuMjE2IDAgMCAxLS4xNTctLjA2N0w0LjY2NyA3IiBzdHJva2U9IiMwQzBDMEMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-bottom.svg
// module id = YfBz
// module chunks = 0